import { Routes } from '@angular/router';
import {
  GeaMesLoginComponent,
  GeaMesCognitoAuthGuard
} from '@gea-mes/cognito';

import { HomeComponent } from './home/home.component';
import { PlantSummaryComponent } from './plant-summary/plant-summary.component';
import { ConfigurationComponent } from './configuration/configuration.component';
import { LogOutPageComponent } from './log-out-page/log-out-page.component';

export const routes: Routes = [
  { path: 'login', component: GeaMesLoginComponent },
  { path: 'logout', component: LogOutPageComponent },
  {
    path: '',
    canActivate: [GeaMesCognitoAuthGuard],
    children: [
      { path: '', redirectTo: '/summary', pathMatch: 'full' },
      { path: 'summary', component: PlantSummaryComponent },
      { path: 'home', component: HomeComponent },
      { path: 'updateConfiguration', component: ConfigurationComponent, data: { type: 'update' } },
      { path: 'configuration', component: ConfigurationComponent, data: { type: 'create' } }
    ]
  },
  { path: '**', redirectTo: '/summary' }
];